/* v8 ignore start */
export { default } from './SimpleWizard';
export { default as reducer } from './SimpleWizard.ducks';

import * as actions from './SimpleWizard.ducks';
export { actions };
